import React, {useState, useEffect} from "react";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";

import { GET_USER_LEVEL } from "../../../helpers";

import { WidgetTresholdLimitMonitor } from "../widgets/WidgetTresholdLimitMonitor";
import { WidgetNotifications } from "../widgets/WidgetNotifications";
import { WidgetGraphSalesReport } from "../widgets/WidgetGraphSalesReport";
import { DaysSelect } from "../partials/DaysSelect";
import { CurrencySelect } from "../partials/CurrencySelect";

export const DashboardPage = (props) => {
  // const [daysFilter, setDaysFilter] = useState('7');

  const [filterPayload, setFilterPayload] = useState({
    from: undefined,
    to: undefined,
  });

  return (
    <>
      <div className="Dashboard__content__top-row">
        <div className="widget__title-wrapper flex">
          <h2>Sales Summary</h2>
          <Link
            className="widget__title-wrapper__link flex"
            to={"/dashboard/salesreport"}
            exact="true"
          >
            View full report
            <div className="icon arrow-right"></div>
          </Link>
        </div>

        <ul className="Dashboard__content__top-row__selectors">
          <li>
            <DaysSelect
              changeGlobalDays={props.changeGlobalDays}
              filterFromTo={setFilterPayload}
            />
          </li>
          <li>
            <CurrencySelect changeGlobalCurrency={props.changeGlobalCurrency} />
          </li>
        </ul>
      </div>

      { parseInt(GET_USER_LEVEL(), 10) < 4 && (
        <div className="simple SalesDetalization__table-filters">
          <div className="input-wrapper datefrom">
            <DatePicker
              dateFormat="yyyy-MM-dd"
              autoComplete="off"
              selected={filterPayload["from"]}
              onChange={(newDate) => {
                setFilterPayload({
                  ...filterPayload,
                  //eslint-disable-next-line
                  ["from"]: newDate,
                });
              }}
              name="from"
              placeholderText="YYYY-MM-DD"
              className="SalesDetalization__search-by-datefrom default-input"
              selectsEnd
            />
          </div>

          <div className="input-wrapper dateto">
            <DatePicker
              dateFormat="yyyy-MM-dd"
              autoComplete="off"
              selected={filterPayload["to"]}
              onChange={(newDate) => {
                setFilterPayload({
                  ...filterPayload,
                  //eslint-disable-next-line
                  ["to"]: newDate,
                });
              }}
              name="to"
              placeholderText="YYYY-MM-DD"
              className="SalesDetalization__search-by-dateto default-input"
              selectsEnd
            />
          </div>
       </div>
      )}

      <WidgetGraphSalesReport
        globalCurrency={props.globalCurrency}
        globalDays={props.globalDays}
        filterPayload={filterPayload}
      />

      <div className="Dashboard__content__widget-row">
        <WidgetTresholdLimitMonitor
          globalCurrency={props.globalCurrency}
          width={"half-width-dashboard"}
          border={"border"}
          filterPayload={filterPayload}
        />

        <WidgetNotifications
          width={"half-width-dashboard"}
          border={"border"}
          filterPayload={filterPayload}
        />
      </div>
    </>
  );
};
